











































































































































































































import Vue from 'vue'
import {
  FolderServiceProxy,
  FileServiceProxy,
  DeleteFileDto
} from '@/service-proxies/app-v2/dnc.service-proxies'
import { getFileDownload } from '@/components/ViewDetail/viewdetail'
import FileList from './components/FileList.vue'
import UploadFile from './components/UploadFile.vue'
import MoreAction from './components/MoreAction.vue'
import LeftTree from './components/LeftTree'
import AddFile from './components/AddFile.vue'
import File from './components/File.vue'
import ViewDetail from '@/components/ViewDetail/index.vue'
import { canPreviewList, previewMode } from '@/utils/commonDef'
const folderservice = new FolderServiceProxy()
const fileservice = new FileServiceProxy()

export default Vue.extend({
  components: {
    FileList,
    UploadFile,
    MoreAction,
    LeftTree,
    AddFile,
    File,
    ViewDetail
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('actions'),
          dataIndex: 'action',
          key: 'action',
          width: 90,
          scopedSlots: { customRender: 'action' }
        },
        {
          title: this.$t('page_my_document_filenm'),
          dataIndex: 'name',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('page_my_document_path'),
          dataIndex: 'allPathName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_my_document_edition'),
          dataIndex: 'vision',
          ellipsis: true,
          width: 88
        },
        {
          title: this.$t('page_my_document_size'),
          dataIndex: 'contentLength',
          width: 88,
          ellipsis: true,
          scopedSlots: { customRender: 'contentLength' }
        },
        {
          title: this.$t('page_my_document_type'),
          dataIndex: 'suffix',
          ellipsis: true,
          width: 88
        },
        {
          title: this.$t('page_plan_create_time'),
          dataIndex: 'updateTime',
          ellipsis: true,
          scopedSlots: { customRender: 'updateTime' }
        }
      ],
      fileslist: [], // 文件列表
      parent: undefined, // 父级id
      uploadvisible: false, // 上传
      selectedids: [], // 选择id集
      selectedRowKeys: [], // 选择文件Id合集
      selectedRows: [],
      addvisible: false, // 新建文档
      addway: '',
      sortTime: true,
      sortName: true,
      sortSize: true,
      sorterDisplayName: '',
      mcvisible: false, // 移动，复制
      getway: '', // 复制移动操作。。。
      folders: [], // 文件夹列表
      Showvalue: 'table', // 默认table展示
      parentid: '0', // 选择id
      detail: {}, // 文件详情
      detailvisible: false, // 文件详情展示
      changeViewEdit: false, // 文件是否编辑
      searchKey: '', // 搜索关键词
      tableLoading: false, // tableloading
      viewContentType: canPreviewList,
      canUpload: false
    }
  },
  computed: {
    candosth() {
      return this.selectedids.length === 0
    }
  },
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = []
      this.selectedids = []
      this.selectedRows = []
    },

    getCheckboxProps(record) {
      return {
        style: {
          display: record.id ? 'block' : 'none'
        },
        props: {
          disabled: record.id ? false : true
        }
      }
    },
    selectTree(id) {
      console.log(id)
      if (id) {
        this.canUpload = true
      } else {
        this.canUpload = false
      }
      this.parentid = id ? id : '0'
      this.getFoldersList(id ? id : 0)
    },
    getFoldersList(id) {
      this.selectedids = []
      this.fileslist = []
      this.folders = []
      this.selectedRowKeys = []
      this.sorterDisplayName = ''
      this.tableLoading = true
      folderservice.folderList(id, this.searchKey).then((res) => {
        if (res) {
          this.fileslist = [...res.folderList, ...res.fileList]

          let dataLength = this.fileslist.length
          let copy = JSON.parse(JSON.stringify(this.fileslist))
          let needPush = 0
          if (dataLength < 30) {
            needPush = 30 - dataLength
            for (var k = 0; k < needPush; k++) {
              let obj = {
                // id: 'none'
                updateTime: ''
              }
              copy.push(obj)
            }
          }
          console.log(this.fileslist, 'mmmmmmmmmmmmmm')
          this.fileslist = JSON.parse(JSON.stringify(copy))

          this.tableLoading = false
        }
      })
    },
    handleShowChange(button: any) {
      // 切换table，表格展示
      this.Showvalue = button.target.value
      this.selectedids = []
      this.selectedRowKeys = []
    },
    sorterTime() {
      this.sortTime = !this.sortTime
      if (this.sortTime) {
        this.fileslist.sort(function (a, b) {
          return a.updateTime < b.updateTime ? 1 : -1
        })
      } else {
        this.fileslist.sort(function (a, b) {
          return a.updateTime > b.updateTime ? 1 : -1
        })
      }
    }, // 日期排序
    sorterSize() {
      this.sortSize = !this.sortSize
      if (this.sortSize) {
        this.fileslist.sort(function (a, b) {
          return a.contentLength < b.contentLength ? 1 : -1
        })
      } else {
        this.fileslist.sort(function (a, b) {
          return a.contentLength > b.contentLength ? 1 : -1
        })
      }
    }, // 大小排序
    sorterName() {
      this.sortName = !this.sortName
      if (this.sortName) {
        this.fileslist.sort(function (a, b) {
          return a.name.localeCompare(b.name)
        })
      } else {
        this.fileslist.sort(function (a, b) {
          return b.name.localeCompare(a.name)
        })
      }
    }, // 姓名排序
    handleTableChange(sorter) {
      this.selectedids = []
      this.fileslist = []
      this.folders = []
      this.selectedRowKeys = []
      this.sorterDisplayName = ''
      this.tableLoading = true
      folderservice.folderList(this.parentid, this.searchKey).then((res) => {
        if (res) {
          this.fileslist = [...res.folderList, ...res.fileList]
          if (sorter.key === 'time') {
            this.sorterDisplayName = this.$t('page_my_document_modify')
            this.sorterTime()
          } else if (sorter.key === 'size') {
            this.sorterDisplayName = this.$t('page_my_document_size')
            this.sorterSize()
          } else {
            this.sorterDisplayName = this.$t('page_my_document_filenm')
            this.sorterName()
          }
          this.tableLoading = false
        }
      })
    },
    handleSearch(value: any) {
      // 搜索
      this.searchKey = value
      this.getFoldersList(this.parentid)
    },
    checkFile(value) {
      if (this.selectedids.indexOf(value.id) === -1) {
        this.selectedids.push(value.id)
        this.selectedRows.push(value)
      } else {
        this.selectedids.splice(this.selectedids.indexOf(value.id), 1)
        this.selectedRows.splice(this.selectedRows.indexOf(value), 1)
      }
    },
    upload() {
      // 上传
      this.uploadvisible = true
    },
    closeUpload(bool: boolean) {
      this.uploadvisible = false
      if (bool) {
        this.$refs.treechild.addLoad()
      }
    },
    handleDelete() {
      // 删除
      const value = new DeleteFileDto({
        sourceIdList: this.selectedids
      })
      fileservice.delete(value).then(() => {
        this.$message.success(this.$t('page_my_document_deletesucess'))
        this.$refs.treechild.addLoad()
      })
    },
    handleGetway(value: any) {
      // 更多操作
      if (value.key === 'Release' || value.key === 'share') {
        this.$message.warning(this.$t('page_my_document_notyet'))
        return
      }
      if (value.key === 'download') {
        this.download()
        return
      }
      this.mcvisible = true
      this.getway = value.key
    },
    rowClick(record: any) {
      return {
        on: {
          dblclick: () => {
            if (record.suffix || record.contentType) {
            } else {
              this.$refs.treechild.onSelectadLoad([record.id])
            }
          }
        }
      }
    },
    changeView() {
      this.changeViewEdit = true
    },
    handleEdit(record: any) {
      if (this.changeViewEdit) {
        this.$confirm({
          title: this.$t('switch_tips_title'),
          content: this.$t('switch_tips_content'),
          onOk: () => {
            this.detail = {}
            if (this.canEdit(record)) {
              this.detail = record
              this.changeViewEdit = false
              this.detailvisible = true
            } else {
              this.detailvisible = false
            }
          },
          onCancel() {
            return
          }
        })
      } else {
        this.detail = {}
        if (this.canEdit(record)) {
          this.detail = record
          this.changeViewEdit = false
          this.detailvisible = true
        } else {
          this.detailvisible = false
        }
      }
    },
    fileClick(record) {
      this.detail = {}
      if (this.canEdit(record)) {
        this.detail = record
        this.detailvisible = true
      } else {
        this.detailvisible = false
      }
    },
    canEdit(record) {
      let bool = false
      if (record.name.indexOf('.') != -1) {
        var a = /.*\.(.*)$/
        const suffix = a.exec(record.name)[1]
        bool = this.viewContentType.includes(suffix.toLowerCase())
      } else {
        bool = true
      }
      if (Object.keys(record).length < 5) {
        bool = false
      }
      return bool
    },
    dblclickFile(record) {
      if (record.suffix || record.contentType) {
      } else {
        this.$refs.treechild.onSelectadLoad([record.id])
      }
    },
    closeDetail(bool) {
      this.detailvisible = false
      this.changeViewEdit = false
      this.detail = {}
      if (bool) {
        this.getFoldersList(this.parentid)
      }
    },
    download() {
      const file = this.selectedRows[0]
      getFileDownload(file.name, file.objectKey).subscribe()
    },
    closeMc(bool: boolean) {
      this.mcvisible = false
      if (bool) {
        this.$refs.treechild.addLoad()
      }
    },
    handleAdd(value: any) {
      // 新建
      this.addvisible = true
      this.addway = value.key
    },
    closeAdd(bool: boolean) {
      this.addvisible = false
      this.addway = ''
      console.log('刷新')
      if (bool) {
        this.$refs.treechild.addLoad()
      }
    },
    onSelectChange(selectedRowKeys: any, selectedRow: any) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRow
      this.selected(selectedRow)
    },
    selected(item: any) {
      this.selectedids = []
      if (item && item.length > 0) {
        item.forEach((element: any) => {
          this.selectedids.push(element.id)
        })
      }
    },
    fileChange(bool) {
      if (bool) {
        this.$refs.treechild.addLoad()
      }
    }
  }
})
